export const environment = {
  production: false,
  version: '1.0.0-beta-3',
  env: 'dev',
  graph: import.meta.env?.NG_APP_SPACES_APP_API_URL || '/graphql',
  API: import.meta.env?.NG_APP_SPACES_APP_API_URL || '/graphql',
  OUTLOOK_CLIENT_ID: import.meta.env?.NG_APP_OUTLOOK_CLIENT_ID || '',
  GOOGLE_CLIENT_ID:
    import.meta.env?.NG_APP_GOOGLE_CLIENT_ID ||
    '152673556551-md13fj9kr1iag38ta0emif3iia3migm9.apps.googleusercontent.com',
  MISSION_CONTROL_URL: import.meta.env?.NG_APP_MISSION_CONTROL_URL || 'http://localhost:4004',
  VISITOR_MANAGEMENT_URL: import.meta.env?.NG_APP_VISITOR_MANAGEMENT_URL || 'http://localhost:4005',
  INDOOR_MAPPING_URL: import.meta.env?.NG_APP_INDOOR_MAPPING_URL || 'http://localhost:4200',
  EMPLOYEE_APP_URL: import.meta.env?.NG_APP_EMPLOYEE_APP_URL || 'http://localhost:4200',
  // The RICOH Workplace desktop app (Tauri). Sign-in happens in the system
  // browser and returns through the app's URL scheme; the desktop reads the
  // usual `#rt=…&t=…` handoff off it. Same value in every environment.
  EMPLOYEE_DESKTOP_URL: import.meta.env?.NG_APP_EMPLOYEE_DESKTOP_URL || 'ricohworkplace://auth',
  KNOWLEDGE_WIKI_URL: import.meta.env?.NG_APP_KNOWLEDGE_WIKI_URL || 'http://localhost:5173',
  INSIGHTS_URL: import.meta.env?.NG_APP_INSIGHTS_URL || 'http://localhost:4211',
  WORKPLACE_SETTINGS_URL: import.meta.env?.NG_APP_WORKPLACE_SETTINGS_URL || 'http://localhost:4600',
  // Visitors (rdx-visitors): reception and visitor admin. Platform mode serves on 4212.
  RDX_VISITORS_URL: import.meta.env?.NG_APP_RDX_VISITORS_URL || 'http://localhost:4212',
  // PostHog project token (public phc_ key). Empty disables analytics.
  POSTHOG_TOKEN: import.meta.env?.NG_APP_POSTHOG_PROJECT_TOKEN?.trim() || '',
  POSTHOG_HOST: import.meta.env?.NG_APP_POSTHOG_HOST?.trim() || 'https://eu.i.posthog.com',
  // Policies linked from the consent banner. Empty uses the default cookie
  // policy page; an empty privacy policy URL leaves that link out.
  // The shared cookie consent banner (@ricohproducts/consent). Off unless
  // NG_APP_CONSENT_ENABLED is "true": PostHog then starts at once, as it did
  // before the banner. Rolled out per environment through that variable.
  CONSENT_ENABLED: import.meta.env?.NG_APP_CONSENT_ENABLED?.trim() === 'true',
  COOKIE_POLICY_URL: import.meta.env?.NG_APP_COOKIE_POLICY_URL?.trim() || '',
  PRIVACY_POLICY_URL: import.meta.env?.NG_APP_PRIVACY_POLICY_URL?.trim() || '',
};
